(ns app.domain.application.guards.bim
  (:require [app.domain.application.guards.utils :as guard-utils]
            [app.domain.bim.attachment-model :as bim-attachment-model]))

(def bim-attachment-has-other-versions?
  {:name    :process.guard/bim-attachment-has-other-versions?
   :type    :guard
   :handler (fn [fsm]
              (let [version (guard-utils/find-child-entity fsm :attachment-version-id)]
                (->> version
                     :entity/parent
                     bim-attachment-model/versions
                     (remove #(= % version))
                     seq
                     boolean)))})

(def bim-attachment-version-compliance-checkable?
  {:name    :process.guard/bim-attachment-version-compliance-checkable?
   :type    :guard
   :handler (fn [fsm]
              (let [version (guard-utils/find-child-entity fsm :attachment-version-id)]
                ;; For prototype we do not require the validation state to be valid, just to exist
                (and (:bim-attachment-version/validation-state version)
                     (->> version
                          :bim-attachment-version/compliance-state
                          ((some-fn nil?
                                    #(contains? #{:bim-attachment-version.compliance-state/invalid
                                                  :bim-attachment-version.compliance-state/not-validated}
                                                %)))))))})

(def bim-attachments-compliance-checked?
  {:name    :process.guard/bim-attachments-compliance-checked?
   :type    :guard
   :handler (fn [{{:keys [target]} :request}]
              (->> (bim-attachment-model/phase-bim-attachments target)
                   (keep bim-attachment-model/latest-version)
                   (every? bim-attachment-model/compliance-checked?)))})

(def guards [bim-attachment-has-other-versions?
             bim-attachment-version-compliance-checkable?
             bim-attachments-compliance-checked?])
